/* ═══════════════════════════════════════════════════════════════════
   DG SPONSORED BANNER — dg-collection-hero.js
   Handles: horizontal scroll arrows + add-to-cart
   ThemeDGCore | Distribution Gauthier
   ═══════════════════════════════════════════════════════════════════ */

/**
 * Scroll the product rail left (-1) or right (1)
 */
function dgSpbScroll(btn, direction) {
    const rail = btn.closest('.dg-spb__rail-wrap').querySelector('.dg-spb__rail');
    if (!rail) return;
    // Scroll by ~2 tile widths
    const tileWidth = rail.querySelector('.dg-spb__tile')?.offsetWidth || 160;
    rail.scrollBy({ left: direction * tileWidth * 2, behavior: 'smooth' });
}

/**
 * Add to cart via Shopify AJAX API
 */
async function dgSpbAddToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    try {
        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!res.ok) throw new Error('Cart error');

        // Success feedback
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        const originalHTML = btn.innerHTML;
        btn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Ajouté !`;

        // Dispatch cart update event for cart drawer
        document.dispatchEvent(new CustomEvent('dg:cart:updated'));

        setTimeout(() => {
            btn.classList.remove('is-added');
            btn.innerHTML = originalHTML;
            btn.disabled = false;
        }, 2000);

    } catch (err) {
        console.error('[DG SPB] Add to cart failed:', err);
        btn.classList.remove('is-loading');
        btn.disabled = false;
    }
}

/**
 * Show/hide scroll arrows based on scroll position
 */
function dgSpbUpdateArrows(rail) {
    const wrap = rail.closest('.dg-spb__rail-wrap');
    if (!wrap) return;
    const prevBtn = wrap.querySelector('.dg-spb__scroll-btn--prev');
    const nextBtn = wrap.querySelector('.dg-spb__scroll-btn--next');
    if (prevBtn) prevBtn.style.opacity = rail.scrollLeft > 10 ? '1' : '0.35';
    if (nextBtn) nextBtn.style.opacity = (rail.scrollLeft + rail.clientWidth < rail.scrollWidth - 10) ? '1' : '0.35';
}

/**
 * Init all sponsored banners on page
 */
function dgSpbInit() {
    document.querySelectorAll('.dg-spb__rail').forEach(rail => {
        // Initial arrow state
        dgSpbUpdateArrows(rail);
        // Update on scroll
        rail.addEventListener('scroll', () => dgSpbUpdateArrows(rail), { passive: true });
    });
}

// Run on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dgSpbInit);
} else {
    dgSpbInit();
}
